import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { PlatformBootstrapService } from 'src/app/modules/bootstrap/services/platform-bootstrap.service';

/** Sur la route '' : redirige vers /bootstrap si la plateforme n'est pas initialisée. */
@Injectable({ providedIn: 'root' })
export class BootstrapGuard implements CanActivate {
  constructor(
    private platformService: PlatformBootstrapService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    const { status } = this.platformService;
    if (status === 'not_initialized' || status === 'failed' || status === 'in_progress') {
      return this.router.createUrlTree(['/bootstrap']);
    }
    return true;
  }
}

/** Sur la route /bootstrap : redirige vers / si la plateforme est déjà initialisée. */
@Injectable({ providedIn: 'root' })
export class AlreadyBootstrappedGuard implements CanActivate {
  constructor(
    private platformService: PlatformBootstrapService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    const { status } = this.platformService;
    if (status === 'not_initialized' || status === 'failed' || status === 'in_progress') {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
